import React, { useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import slide1 from 'evcharging/assets/ev-charger/slide1.png';
import slide2 from 'evcharging/assets/ev-charger/slide2.png';
import slide3 from 'evcharging/assets/ev-charger/slide3.png';
import slide4 from 'evcharging/assets/ev-charger/slide4.png';
import slide5 from 'evcharging/assets/ev-charger/slide5.png';
import { css } from '@emotion/css';
import SliderRoundedArrows from 'evcharging/components/SliderRoundedArrows';
import useI18n from 'evcharging/hooks/useI18n';
import Image from 'next/image';

const items = [slide1, slide2, slide3, slide4, slide5];

const responsive = {
  mobile: {
    breakpoint: {
      max: 600,
      min: 0,
    },
    items: 1,
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 600,
    },
    items: 1,
  },
  desktop: {
    breakpoint: {
      max: 4000,
      min: 1025,
    },
    items: 1,
  },
};

const settings = {
  responsive,
  additionalTransfrom: 0,
  minimumTouchDrag: 50,
  arrows: false,
  swipeable: true,
  ssr: true,
  draggable: false,
  keyBoardControl: false,
  slidesToSlide: 1,
  showDots: true,
};

const ProductImagesSlider = () => {
  const ref = useRef(null);
  const [slide, setSlide] = useState(0);
  const [loading, setLoading] = useState(false);
  const [disablePrev, setDisablePrev] = useState(true);
  const [disableNext, setDisableNext] = useState(false);
  const { t } = useI18n();

  const prev = () => {
    if (!loading) {
      // @ts-ignore
      ref.current.previous();
      setSlide(slide === 0 ? items.length - 1 : slide - 1);
    }
  };

  const next = () => {
    if (!loading) {
      // @ts-ignore
      ref.current.next();
      setSlide(slide >= items.length - 1 ? 0 : slide + 1);
    }
  };

  const onBeforeChange = (nextSlide: number) => {
    setDisablePrev(nextSlide === 0);
    setDisableNext(nextSlide >= items.length - 1);
    setLoading(true);
  };

  return (
    <div className={styles.root}>
      <SliderRoundedArrows
        next={next}
        prev={prev}
        disablePrev={disablePrev}
        disableNext={disableNext}
      />
      <Carousel
        {...settings}
        ref={ref}
        beforeChange={onBeforeChange}
        afterChange={() => setLoading(false)}
      >
        {items.map((src, index) => (
          <Image src={src} alt={t('charger.calc.alt')} key={index} width={513} height={542} />
        ))}
      </Carousel>
    </div>
  );
};

const styles = {
  root: css`
    position: relative;
  `,
};

export default ProductImagesSlider;
